import {Box, Text} from '@binance/uikit'

export const NoData = title => (
  <Box textAlign="center" mt={8}>
    <Text.Base fontSize={2}>You have no {title}.</Text.Base>
  </Box>
)
